module.exports = __webpack_public_path__ + "img/image19.863a3950.png";